import { FaqService } from "@vahak/core/dist/_services/faq.service";
import { useDefaultTopLayout } from "components/layout/layout-methods";

export const getOnlineTruckBookingPageLayout = useDefaultTopLayout;

export const getOnlineTruckBookingStaticProps = async () => {
    const { faqs } = await FaqService.getFaqsByCateg({
        categSlug: "booking-trucks"
    });

    return { faqs };
};
